"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6205],{

/***/ 25384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports encodeImageUrl, seoKeys, emptySeo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12104);




var encodeImageUrl = function(baseUrl, params) {
    // Remove double slashes from the URL path (except for the protocol part)
    var correctedBaseUrl = baseUrl.replace(/([^:]\/)\/+/g, "$1");
    var queryString = Object.keys(params).map(function(key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
    }).join("&");
    return "".concat(correctedBaseUrl, "?").concat(queryString);
};
var seoKeys = {
};
for(var key in seoKeys){
    seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}
var emptySeo = {
    title: " ",
    description: "",
    keywords: ""
};
var SeoMetaData = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: data && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
            title: data.title,
            description: data.description || "",
            additionalMetaTags: [
                {
                    name: "title",
                    content: data.title
                },
                {
                    name: "keywords",
                    content: data.keywords
                },
                {
                    name: "description",
                    content: data.description
                }, 
            ],
            openGraph: {
                title: data.title,
                description: data.description || "",
                images: data.image ? [
                    {
                        url: (0,_createImageApiUrl__WEBPACK_IMPORTED_MODULE_3__/* .createImageApiUrl */ .h)(data.image.imageUrl),
                        alt: data.image.alt,
                        width: 1200,
                        height: 630
                    }, 
                ] : []
            },
            noindex: data.noIndex,
            nofollow: data.noIndex
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(SeoMetaData));


/***/ }),

/***/ 11439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13328);


var useShopUrl = function(modelId) {
    var selectedColorCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.color;
    }).selectedColorCode;
    var selectedDetailingCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.detailing;
    }).selectedDetailingCode;
    var selectedUpholsteryCode = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.upholstery;
    }).selectedUpholsteryCode;
    var selectedAccessoriesCodes = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.accessories;
    }).selectedAccessoriesCodes;
    var model = (0,store__WEBPACK_IMPORTED_MODULE_1__/* .useTypedSelector */ .ix)(function(state) {
        return state.wizard;
    }).model;
    var getShopUrl = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (!model || model.id !== modelId) return "/shop/".concat(modelId);
        var url = new URLSearchParams();
        if (selectedColorCode) url.append("color", selectedColorCode);
        if (selectedDetailingCode) url.append("detailing", selectedDetailingCode);
        if (selectedUpholsteryCode) url.append("upholstery", selectedUpholsteryCode);
        if (selectedAccessoriesCodes && Array.isArray(selectedAccessoriesCodes)) {
            selectedAccessoriesCodes.forEach(function(code) {
                return url.append("accessories", code);
            });
        }
        return "/shop/".concat(modelId, "?").concat(url.toString()) || 0;
    }, [
        model,
        modelId,
        selectedColorCode,
        selectedDetailingCode,
        selectedUpholsteryCode,
        selectedAccessoriesCodes, 
    ]);
    return getShopUrl;
};
/* harmony default export */ __webpack_exports__["Z"] = (useShopUrl);


/***/ }),

/***/ 90227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ buildShopLink; }
/* harmony export */ });
var buildShopLink = function(detailing, color, carId) {
    var utmParams = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var details = detailing && "detailing=".concat(detailing);
    var colorParam = color && "&color=".concat(color);
    var utmParamsParam = utmParams && "&".concat(utmParams);
    return "/shop/".concat(carId, "/?").concat(details).concat(colorParam).concat(utmParamsParam, "#/detailing");
};


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ createImageApiUrl; }
/* harmony export */ });
function createImageApiUrl(originalUrl) {
    var baseUrl = "https://www.mazda.co.il";
    var apiUrl = "https://api.mazda.co.il";
    if (!baseUrl || !apiUrl) {
        throw new Error("Environment variables ORIGIN and API_URL must be set");
    }
    // Extract the relative path from the original URL
    var relativePath = originalUrl.replace(apiUrl, "");
    // Construct the API URL
    return "".concat(baseUrl, "/api/ogimage").concat(encodeURI(relativePath));
}


/***/ }),

/***/ 46973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var common_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87018);
/* harmony import */ var common_bit_hooks_useShopUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11439);
/* harmony import */ var common_bit_NextImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49138);
/* harmony import */ var common_bit_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60687);
/* harmony import */ var common_bit_utils_slugify__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57833);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50067);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22546);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        /* Base margin calculation: as viewport height decreases, margin increases */\n        margin-top: calc(-20vh - (1000px - 100vh) * 0.15);\n        margin-bottom: calc(-12vh - (1000px - 100vh) * 0.15);\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  ",
        " {\n    flex-grow: 1;\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: max-content;\n  box-sizing: border-box;\n  height: max-content;\n  display: flex;\n  justify-content: center;\n  ",
        " {\n    height: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        @media (max-height: 750px) {\n          width: 550px;\n        }\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        min-height: 200px;\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      opacity: 0.6;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  aspect-ratio: 16 / 9;\n  height: auto;\n  width: 100%;\n  min-height: 100px;\n  transform: ",
        ";\n  z-index: ",
        ";\n  transition: transform 0.3s linear;\n  ",
        " {\n    transform: ",
        ";\n    ",
        "\n  }\n  ",
        " {\n    min-height: 150px;\n    ",
        "\n  }\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: static;\n  display: inline;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}









var StyledSwiperWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorImageSwiper__StyledSwiperWrapper",
    componentId: "sc-7c157ece-0"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject());
});
var StyledSwiperJs = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .tq).attrs({}).withConfig({
    displayName: "ColorImageSwiper__StyledSwiperJs",
    componentId: "sc-7c157ece-1"
})(_templateObject2());
var StyledSwiperSlide = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .SwiperSlide */ .o5).withConfig({
    displayName: "ColorImageSwiper__StyledSwiperSlide",
    componentId: "sc-7c157ece-2"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorImageSwiper__StyledImageWrapper",
    componentId: "sc-7c157ece-3"
})(_templateObject7(), function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "scale(1) translateY(0px)" : "scale(0.5) translateY(-20%)";
}, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "2" : "1";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "scale(1)" : "scale(0.7)";
}, function(p) {
    return p.$isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject4());
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject5());
}, function(p) {
    return p.$isShop && !p.$isInShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .css */ .iv)(_templateObject6());
});
var StyledLinkReplacement = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ColorImageSwiper__StyledLinkReplacement",
    componentId: "sc-7c157ece-4"
})(_templateObject8());
var ColorImageSwiper = function(param) {
    var carsStrip = param.carsStrip, setActiveIndex = param.setActiveIndex, colorIndex = param.colorIndex, setControlledSwiper = param.setControlledSwiper, controlledSwiper = param.controlledSwiper, isShop = param.isShop;
    var initialSlide = 0;
    var getCarLink = function(card) {
        var futureModel = (card === null || card === void 0 ? void 0 : card.carState) === "Future";
        var carLink = futureModel ? card.link : "/model/[modelId]/[modelSlug]".replace("[modelId]", card.id.toString()).replace("[modelSlug]", (0,common_bit_utils_slugify__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(card.name));
        return carLink;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSwiperWrapper, {
        $isShop: isShop,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSwiperJs, {
            modules: [
                swiper__WEBPACK_IMPORTED_MODULE_6__/* .A11y */ .s5,
                swiper__WEBPACK_IMPORTED_MODULE_6__/* .Keyboard */ .N1,
                swiper__WEBPACK_IMPORTED_MODULE_6__/* .Parallax */ .VS,
                swiper__WEBPACK_IMPORTED_MODULE_6__/* .Controller */ .Qr
            ],
            loop: true,
            parallax: true,
            initialSlide: initialSlide,
            allowTouchMove: true,
            grabCursor: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            resizeObserver: true,
            onSlideChange: function(swiper) {
                setActiveIndex(swiper.realIndex);
            },
            onSwiper: setControlledSwiper,
            controller: {
                control: controlledSwiper || undefined,
                by: "slide"
            },
            keyboard: {
                enabled: true
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.5,
                    spaceBetween: -100
                },
                // when mui md up:
                960: {
                    slidesPerView: 2.1
                }
            },
            init: false,
            children: carsStrip.map(function(data, index) {
                var ref;
                // eslint-disable-next-line react-hooks/rules-of-hooks
                var carLink = (0,common_bit_hooks_useShopUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((ref = carsStrip[index]) === null || ref === void 0 ? void 0 : ref.id);
                var LinkWrap = !(data === null || data === void 0 ? void 0 : data.isInShop) && isShop ? StyledLinkReplacement : common_bit_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSwiperSlide, {
                    children: function(param) {
                        var isActive = param.isActive;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImageWrapper, {
                            $isActive: isActive,
                            $isShop: isShop,
                            $isInShop: data === null || data === void 0 ? void 0 : data.isInShop,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LinkWrap, {
                                href: isShop ? carLink : getCarLink(data),
                                onClick: function() {
                                    return (0,common_analytics__WEBPACK_IMPORTED_MODULE_2__/* .trackModelSliderHpClicks */ .W)();
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_bit_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    image: {
                                        imageUrl: data.modelColors[colorIndex].image.imageUrl,
                                        alt: data.modelColors[colorIndex].image.alt
                                    },
                                    cover: false
                                })
                            })
                        });
                    }
                }, "swiperr-".concat(index));
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ColorImageSwiper);


/***/ }),

/***/ 65138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var common_bit_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60687);
/* harmony import */ var common_buildShopLink__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90227);
/* harmony import */ var components_shopFeatures_color_colorSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58976);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21325);
/* harmony import */ var reusable_MoreDetailsButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90404);
/* harmony import */ var store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13328);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: 0;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        height: auto;\n        min-height: 0;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 190px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: auto;\n  margin-top: 20px;\n  ",
        "\n  ",
        " {\n    margin-bottom: 20px;\n    height: 190px;\n    margin-top: 0px;\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-size: 20px;\n      font-weight: 400;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: MazdaType, OENaPro, sans-serif;\n  font-size: 24px;\n  text-align: center;\n  letter-spacing: 0.08em;\n  font-weight: 400;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  min-width: 270px;\n  justify-content: ",
        ";\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 10px;\n  ",
        " {\n    margin-bottom: 16px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 1px;\n  height: 62px;\n  background: ",
        ";\n  transform: rotate(29.19deg);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n  text-align: center;\n  margin: 0 auto;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  margin-top: 4px;\n  height: 23px;\n  color: ",
        ";\n  ",
        " {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  width: fit-content;\n  margin: 0 auto;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 10px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: baseline;\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}










var StyledFooterDiv = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SwiperFooterText__StyledFooterDiv",
    componentId: "sc-14605e2c-0"
})(_templateObject2(), function(p) {
    return p.$isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject());
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject1());
});
var StyledPriceTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(theme_shared__WEBPACK_IMPORTED_MODULE_6__/* .TypographyCenter */ .kc).attrs({
    variant: "body1"
}).withConfig({
    displayName: "SwiperFooterText__StyledPriceTitle",
    componentId: "sc-14605e2c-1"
})(_templateObject4(), function(p) {
    return p.theme.colors.onyx;
}, function(p) {
    return p.isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject3());
});
var StyledPrice = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "SwiperFooterText__StyledPrice",
    componentId: "sc-14605e2c-2"
})(_templateObject5());
var StyledPriceWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SwiperFooterText__StyledPriceWrapper",
    componentId: "sc-14605e2c-3"
})(_templateObject6(), function(p) {
    return p.$justify;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledPriceLine = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SwiperFooterText__StyledPriceLine",
    componentId: "sc-14605e2c-4"
})(_templateObject7(), function(p) {
    return p.theme.colors.nonExistentLightGray;
});
var StyledLicenseFee = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "SwiperFooterText__StyledLicenseFee",
    componentId: "sc-14605e2c-5"
})(_templateObject8(), function(p) {
    return p.theme.colors.black;
});
var StyledPurchase = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "SwiperFooterText__StyledPurchase",
    componentId: "sc-14605e2c-6"
})(_templateObject9(), function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledDetailsDiv = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(framer_motion__WEBPACK_IMPORTED_MODULE_9__/* .motion.div */ .E.div).withConfig({
    displayName: "SwiperFooterText__StyledDetailsDiv",
    componentId: "sc-14605e2c-7"
})(_templateObject10());
var StyledDetailsText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "body2"
}).withConfig({
    displayName: "SwiperFooterText__StyledDetailsText",
    componentId: "sc-14605e2c-8"
})(_templateObject11());
var StyledShopText = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(StyledDetailsText).withConfig({
    displayName: "SwiperFooterText__StyledShopText",
    componentId: "sc-14605e2c-9"
})(_templateObject12());
var StyledDiv = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SwiperFooterText__StyledDiv",
    componentId: "sc-14605e2c-10"
})(_templateObject14(), function(p) {
    return p.$marginTop && "margin-top: ".concat(p.$marginTop, "px;");
}, function(p) {
    return p.$marginBottom && "margin-bottom: ".concat(p.$marginBottom, "px;");
}, function(p) {
    return p.isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(_templateObject13());
});
var SwiperFooterText = function(param) {
    var card = param.card, activeIndex = param.activeIndex, link = param.link, colorIndex = param.colorIndex, isShop = param.isShop;
    var ref;
    var dispatch = (0,store__WEBPACK_IMPORTED_MODULE_5__/* .useAppDispatch */ .TL)();
    var carLink = link;
    var detailData = (0,store__WEBPACK_IMPORTED_MODULE_5__/* .useTypedSelector */ .ix)(function(state) {
        return state === null || state === void 0 ? void 0 : state.detailing;
    });
    var detailing = detailData.detailing;
    var carId = card.id, modelColors = card.modelColors;
    var color = (ref = modelColors[colorIndex]) === null || ref === void 0 ? void 0 : ref.colorCode;
    var shopUrl = (0,common_buildShopLink__WEBPACK_IMPORTED_MODULE_10__/* .buildShopLink */ .u)(detailing, color, carId);
    var saveSelectedColor = function() {
        dispatch((0,components_shopFeatures_color_colorSlice__WEBPACK_IMPORTED_MODULE_3__/* .setSelectedColor */ .El)(card.modelColors[activeIndex].colorCode));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledFooterDiv, {
        $isShop: isShop,
        children: [
            card.carState !== "Future" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPriceWrapper, {
                $justify: (card === null || card === void 0 ? void 0 : card.mountlyPayment) && !isShop ? "space-between" : "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDiv, {
                        isShop: isShop,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPriceTitle, {
                                isShop: isShop,
                                children: isShop ? "מ-" : "החל מ-"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPrice, {
                                children: [
                                    "₪",
                                    card.price.toLocaleString()
                                ]
                            })
                        ]
                    }),
                    !!(card === null || card === void 0 ? void 0 : card.mountlyPayment) && !isShop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPriceLine, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDiv, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPriceTitle, {
                                        children: "החזר חודשי החל מ-"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPrice, {
                                        children: [
                                            "₪",
                                            card.mountlyPayment ? card.mountlyPayment.toLocaleString() : 0
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDiv, {
                $marginBottom: 10,
                children: [
                    (card === null || card === void 0 ? void 0 : card.licenceFee) > 0 && card.carState !== "Future" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledLicenseFee, {
                        children: [
                            "+ אגרת רישוי של ₪",
                            card.licenceFee.toLocaleString(),
                            " כולל מע״מ"
                        ]
                    }),
                    card.isInShop && !isShop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_bit_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        href: shopUrl,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPurchase, {
                            children: "ניתן להזמנה מיידית אונליין"
                        })
                    })
                ]
            }),
            card.isInShop || !isShop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_bit_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                href: carLink,
                onClick: saveSelectedColor,
                "aria-label": "Find out more about ".concat(card.name, ". גלו עוד על  ").concat(card.name, " "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDetailsDiv, {
                    layout: true,
                    children: [
                        !isShop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDetailsText, {
                            children: "גלו עוד"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledShopText, {
                            children: "לתחילת תהליך רכישה אונליין"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_MoreDetailsButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    ]
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_bit_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                href: "/contact-us",
                onClick: saveSelectedColor,
                "aria-label": "Find out more about ".concat(card.name, ". גלו עוד על  ").concat(card.name, " "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDetailsDiv, {
                    layout: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledShopText, {
                            children: "לבדיקת זמינות באולם"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_MoreDetailsButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwiperFooterText);


/***/ }),

/***/ 96164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var common_bit_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60687);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n      ",
        " {\n        p {\n          font-size: 24px;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  flex-shrink: 0;\n  margin-top: 20px;\n  ",
        " {\n    ",
        "\n  }\n  ",
        " {\n    margin-bottom: 50px;\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: calc(100vw - 20px);\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: max-content;\n  font-size: 32px;\n  font-size: ",
        "px;\n  margin: 0 auto;\n  height: 45px;\n  letter-spacing: 0.06em;\n  font-weight: 400;\n  ",
        " {\n    font-size: 32px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  height: 40px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  height: 32px;\n  letter-spacing: 0.08em;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var StyledTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SwiperTopText__StyledTitleDiv",
    componentId: "sc-adc0bb0-0"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return !p.isShop ? "height: 117px;" : "height: 65px;";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.isShop && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(_templateObject(), function(p) {
        return p.theme.breakpoints.down("sm");
    });
});
var StyledWrapperText = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SwiperTopText__StyledWrapperText",
    componentId: "sc-adc0bb0-1"
})(_templateObject2());
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "SwiperTopText__StyledTitle",
    componentId: "sc-adc0bb0-2"
})(_templateObject3(), function(p) {
    return p.$fontSize;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledComingSoonText = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    variant: "h1",
    component: "h2"
}).withConfig({
    displayName: "SwiperTopText__StyledComingSoonText",
    componentId: "sc-adc0bb0-3"
})(_templateObject4(), function(p) {
    return p.theme.colors.mazdaRed;
});
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "SwiperTopText__StyledText",
    componentId: "sc-adc0bb0-4"
})(_templateObject5());
var SwiperTopTextContent = function(param) {
    var carData = param.carData, fontSize = param.fontSize, textRef = param.textRef, isShop = param.isShop;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            (carData === null || carData === void 0 ? void 0 : carData.carState) === "Future" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledComingSoonText, {
                children: "COMING SOON"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapperText, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
                    ref: textRef,
                    $fontSize: fontSize,
                    children: carData === null || carData === void 0 ? void 0 : carData.name
                })
            }),
            !isShop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledText, {
                children: carData === null || carData === void 0 ? void 0 : carData.secondaryTitle
            })
        ]
    });
};
var SwiperTopText = function(param) {
    var carData = param.carData, carLink = param.carLink, isShop = param.isShop;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(32), fontSize = ref[0], setFontSize = ref[1];
    var textRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        var text = textRef.current;
        var textRect = text.getClientRects()[0];
        var textWidth = textRect.width;
        var elementWidth = text.parentElement.offsetWidth;
        if (textWidth >= elementWidth) {
            //text is more than one line
            //adjust the font size for it to fit in one line and not overflow
            var fontSize = elementWidth / textWidth * 32;
            setFontSize(fontSize);
        } else {
            setFontSize(32);
        }
    }, [
        carData.name
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitleDiv, {
        role: "heading",
        "aria-level": 2,
        isShop: isShop,
        children: carLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_bit_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: carLink,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperTopTextContent, {
                carData: carData,
                fontSize: fontSize,
                textRef: textRef,
                isShop: isShop
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SwiperTopTextContent, {
            carData: carData,
            fontSize: fontSize,
            textRef: textRef,
            isShop: isShop
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwiperTopText);


/***/ }),

/***/ 90404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reusable_MoreDetailsButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./reusable/icons/MoreDetailsHoverIcon.tsx





var SvgComponent = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var w = 50;
    var h = 50;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_b_528_47029)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "50",
                        height: "50",
                        rx: "25",
                        fill: "#3A3D46"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.25 29.5L21.75 25L26.25 20.5",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1",
                        y: "1",
                        width: "48",
                        height: "48",
                        rx: "24",
                        stroke: "#3A3D46",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_b_528_47029",
                    x: "-10",
                    y: "-10",
                    width: "70",
                    height: "70",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            in: "BackgroundImageFix",
                            stdDeviation: "5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "SourceAlpha",
                            operator: "in",
                            result: "effect1_backgroundBlur_528_47029"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_backgroundBlur_528_47029",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var MoreDetailsHoverIcon = (SvgComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(22038);
;// CONCATENATED MODULE: ./reusable/icons/MoreDetailsIcon.tsx






var MoreDetailsIcon_SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? colors/* default.borderGrey */.Z.borderGrey : _color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color"
    ]);
    var w = 50;
    var h = 50;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                filter: "url(#filter0_b_528_46937)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M26.25 29.5L21.75 25L26.25 20.5",
                        stroke: "#101010",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        x: "1",
                        y: "1",
                        width: "48",
                        height: "48",
                        rx: "24",
                        stroke: "#101010",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                    id: "filter0_b_528_46937",
                    x: "-10",
                    y: "-10",
                    width: "70",
                    height: "70",
                    filterUnits: "userSpaceOnUse",
                    colorInterpolationFilters: "sRGB",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                            floodOpacity: "0",
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                            in: "BackgroundImageFix",
                            stdDeviation: "5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feComposite", {
                            in2: "SourceAlpha",
                            operator: "in",
                            result: "effect1_backgroundBlur_528_46937"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                            mode: "normal",
                            in: "SourceGraphic",
                            in2: "effect1_backgroundBlur_528_46937",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var MoreDetailsIcon = (MoreDetailsIcon_SvgComponent);

;// CONCATENATED MODULE: ./reusable/MoreDetailsButton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px;\n  svg {\n    &:first-child {\n      display: block;\n    }\n    &:last-child {\n      display: none;\n    }\n  }\n  &:hover {\n    svg {\n      &:first-child {\n        display: none;\n      }\n      &:last-child {\n        display: block;\n      }\n    }\n  }\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    displayName: "MoreDetailsButton__StyledIconButton",
    componentId: "sc-f1a54347-0"
})(_templateObject());
var MoreDetailsButton = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIconButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreDetailsIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreDetailsHoverIcon, {})
        ]
    }));
};
/* harmony default export */ var reusable_MoreDetailsButton = (MoreDetailsButton);


/***/ })

}]);